import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  classId: '',
  titleName: '',
};

const classSlice = createSlice({
  name: 'class',
  initialState,
  reducers: {
    setClassInfo(state, action) {
      state.classId = action.payload.classId;
      state.titleName = action.payload.titleName;
    },
    clearClassInfo(state) {
      state.classId = '';
      state.titleName = '';
    },
    setTitleName(state, action) {
      state.titleName = action.payload;
    },
    setClassId(state, action) {
      state.classId = action.payload;
    },
  },
});

export const { setClassInfo, clearClassInfo, setTitleName, setClassId } =
  classSlice.actions;
export default classSlice.reducer;
